import createPalette, {
  PaletteOptions,
} from '@material-ui/core/styles/createPalette';

const paletteOverrides: PaletteOptions = {
  common: {
    black: '#000',
    white: '#fff',
  },
  type: 'light',
  primary: {
    light: '#17D615',
    main: '#00AB0F',
    dark: '#227819',
    contrastText: '#fff',
  },
  secondary: {
    light: '#fff',
    main: '#fff',
    dark: '#00AB0F',
    contrastText: '#227819',
  },
  error: {
    light: '#E70000',
    main: '#E70000',
    dark: '#E70000',
    contrastText: '#fff',
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  grey: {
    '50': '#fafafa',
    '100': '#f5f5f5',
    '200': '#eeeeee',
    '300': '#e0e0e0',
    '400': '#bdbdbd',
    '500': '#9e9e9e',
    '600': '#757575',
    '700': '#616161',
    '800': '#424242',
    '900': '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.46)',
    hint: 'rgba(0, 0, 0, 0.38)',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#fff',
    default: '#fafafa',
  },
};

const defaultPallete = createPalette(paletteOverrides);
export default defaultPallete;
